import React, { useMemo, useRef } from 'react';
import {
    Avatar,
    TableCellLayout,
    TableColumnDefinition,
    createTableColumn,
    makeStyles,
    Button,
    tokens,
    Tooltip,
} from "@fluentui/react-components";
import {
    Organization20Regular,
    Mail20Regular,
    ArrowForwardDownPerson20Regular,
    Edit20Regular,
} from "@fluentui/react-icons";
import { useNavigate } from 'react-router';
import { type ICustomer } from '../IDB';
import { AuthenticatedTemplate } from '@azure/msal-react';
import { CustomerSearch, SortState } from '../components/CustomerSearch';

const useStyles = makeStyles({
    root: {
        padding: tokens.spacingVerticalXXL,
        marginLeft: '260px', // Width of navbar
        overflow: 'auto',
        maxHeight: 'calc(100vh - 30px)'
    },
    search: {
        marginBottom: tokens.spacingVerticalL
    },
    actions: {
        display: 'flex',
        gap: tokens.spacingHorizontalS,
    }
});

export const CustomerList = () => {
    const styles = useStyles();
    const navigate = useNavigate();
    const containerRef = useRef<HTMLDivElement>(null);

    const columns: TableColumnDefinition<ICustomer>[] = [
        createTableColumn<ICustomer>({
            columnId: "company",
            compare: (a, b) => {
                return a.company.name.localeCompare(b.company.name);
            },
            renderHeaderCell: () => {
                return "Company";
            },
            renderCell: (item) => {
                return (
                    <TableCellLayout aria-label="company" media={<Organization20Regular />}>
                        {item.company.name}
                    </TableCellLayout>
                );
            },
        }),
        createTableColumn<ICustomer>({
            columnId: "name",
            renderHeaderCell: () => {
                return "Recipient";
            },
            renderCell: (item) => {
                return (
                    <TableCellLayout aria-label="name" media={
                        <Avatar
                            aria-label={item.name}
                            name={item.name}
                        />
                    }>
                        {item.name}
                    </TableCellLayout>
                );
            },
        }),
        createTableColumn<ICustomer>({
            columnId: "email",
            renderHeaderCell: () => {
                return "Email";
            },
            renderCell: (item) => {
                return (
                    <TableCellLayout aria-label="email address" media={<Mail20Regular />}>
                        {item.email}
                    </TableCellLayout>
                );
            },
        }),
        createTableColumn<ICustomer>({
            columnId: "actions",
            renderHeaderCell: () => {
                return "Actions";
            },
            renderCell: (item) => {
                return (
                    <div className={styles.actions}>
                        <Tooltip content="View Customer Licenses" relationship="label">
                            <Button aria-label="View Customer" icon={<ArrowForwardDownPerson20Regular />} onClick={() => navigate(`/customers/${item.id}`)} />
                        </Tooltip>
                        <Tooltip content="Edit Customer" relationship="label">
                            <Button aria-label="Edit Customer" icon={<Edit20Regular />} onClick={() => navigate(`/addcustomer/${item.id}`)} />
                        </Tooltip>
                    </div>
                );
            },
        }),
    ];

    const defaultSortState = useMemo<SortState>(() => ({ sortColumn: "created", sortDirection: "ascending" }), []);

    return (
        <div className={styles.root} ref={containerRef}>
            <AuthenticatedTemplate>
                <CustomerSearch
                    columns={columns}
					defaultSortState={defaultSortState}
                    onSelected={() => null}
                    prepopulateSearch={true}
                    sortable={true}
                    containerRef={containerRef}
                />
            </AuthenticatedTemplate>
        </div>
    )
};